import React from 'react';

const Down = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.84088 5.87213C4.17038 5.54262 4.70462 5.54262 5.03412 5.87213L9.5 10.338L13.9659 5.87213C14.2954 5.54262 14.8296 5.54262 15.1591 5.87213C15.4886 6.20163 15.4886 6.73587 15.1591 7.06537L10.0966 12.1279C9.76712 12.4574 9.23288 12.4574 8.90338 12.1279L3.84088 7.06537C3.51137 6.73587 3.51137 6.20163 3.84088 5.87213Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default Down;